import { createCavernScene } from "./cavernSceneFactory";
import {
  CRYSTAL_BASIN_SCENE_KEY,
  EAST_PASSAGE_SCENE_KEY,
  EAST_PASSAGE_SCENE_ROUTING,
  ECHO_VAULT_SCENE_KEY,
  SHATTERED_REACH_SCENE_KEY,
} from "./eastPassageRoutes";

const buildScene = (sceneKey) =>
  createCavernScene({
    sceneKey,
    ...EAST_PASSAGE_SCENE_ROUTING[sceneKey],
  });

export const EastPassageScene = buildScene(EAST_PASSAGE_SCENE_KEY);
export const CrystalBasinScene = buildScene(CRYSTAL_BASIN_SCENE_KEY);
export const EchoVaultScene = buildScene(ECHO_VAULT_SCENE_KEY);
export const ShatteredReachScene = buildScene(SHATTERED_REACH_SCENE_KEY);
